const triggerResize = (page = '') => {
  console.log(page);
  window.dispatchEvent(new Event('resize'));
};

export { triggerResize };